// DraggableContainer.tsx
import React from 'react'
import { useDrag } from 'react-dnd'

interface DraggableContainerProps {
  id: string;
}

const DraggableContainer: React.FC<DraggableContainerProps> = ({ id }) => {
  const [{ isDragging }, dragRef] = useDrag(() => ({
    type: 'CONTAINER',
    item: { id },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }))

  return (
    <div
      ref={dragRef}
      style={{
        padding: '10px',
        margin: '10px 0',
        backgroundColor: isDragging ? '#d3d3d3' : '#f9f9f9',
        border: '1px solid #ccc',
        borderRadius: '4px',
        cursor: 'move',
      }}
    >
      Container {/* {id} */}
    </div>
  )
}

export default DraggableContainer
